import _slicedToArray from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/near-peer-app/nearpeer-frontend/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children"];
import { LeafletProvider, createContainerComponent, createControlHook, createElementHook, createElementObject, extendContext, useLeafletContext } from '@react-leaflet/core';
import { Control } from 'leaflet';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
export var useLayersControlElement = createElementHook(function createLayersControl(_ref, ctx) {
  var _c = _ref.children,
    options = _objectWithoutProperties(_ref, _excluded);
  var control = new Control.Layers(undefined, undefined, options);
  return createElementObject(control, extendContext(ctx, {
    layersControl: control
  }));
}, function updateLayersControl(control, props, prevProps) {
  if (props.collapsed !== prevProps.collapsed) {
    if (props.collapsed === true) {
      control.collapse();
    } else {
      control.expand();
    }
  }
});
export var useLayersControl = createControlHook(useLayersControlElement);
// @ts-ignore
export var LayersControl = createContainerComponent(useLayersControl);
export function createControlledLayer(addLayerToControl) {
  return function ControlledLayer(props) {
    var parentContext = useLeafletContext();
    var propsRef = useRef(props);
    var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      layer = _useState2[0],
      setLayer = _useState2[1];
    var layersControl = parentContext.layersControl,
      map = parentContext.map;
    var addLayer = useCallback(function (layerToAdd) {
      if (layersControl != null) {
        if (propsRef.current.checked) {
          map.addLayer(layerToAdd);
        }
        addLayerToControl(layersControl, layerToAdd, propsRef.current.name);
        setLayer(layerToAdd);
      }
    }, [layersControl, map]);
    var removeLayer = useCallback(function (layerToRemove) {
      layersControl === null || layersControl === void 0 || layersControl.removeLayer(layerToRemove);
      setLayer(null);
    }, [layersControl]);
    var context = useMemo(function () {
      return extendContext(parentContext, {
        layerContainer: {
          addLayer: addLayer,
          removeLayer: removeLayer
        }
      });
    }, [parentContext, addLayer, removeLayer]);
    useEffect(function () {
      if (layer !== null && propsRef.current !== props) {
        if (props.checked === true && (propsRef.current.checked == null || propsRef.current.checked === false)) {
          map.addLayer(layer);
        } else if (propsRef.current.checked === true && (props.checked == null || props.checked === false)) {
          map.removeLayer(layer);
        }
        propsRef.current = props;
      }
    });
    return props.children ? /*#__PURE__*/React.createElement(LeafletProvider, {
      value: context
    }, props.children) : null;
  };
}
LayersControl.BaseLayer = createControlledLayer(function addBaseLayer(layersControl, layer, name) {
  layersControl.addBaseLayer(layer, name);
});
LayersControl.Overlay = createControlledLayer(function addOverlay(layersControl, layer, name) {
  layersControl.addOverlay(layer, name);
});